import short from "short-uuid";

let eventAdded = false;
let lastWidthCallback = null;
const resizeCallbacks = [];
const consoleWarn = "windowResize: No callback specified.";

const runCallback = (callbackDetails) => {
    const { fn, ctx, params = [] } = callbackDetails;

    if (params.length === 0) {
        params.push(window.innerWidth);
    }

    fn.apply(ctx, params);
};

const runCallbacks = () => {
    const currentWidthCallback = window.innerWidth;
    if (lastWidthCallback !== currentWidthCallback) {
        lastWidthCallback = currentWidthCallback;
        resizeCallbacks.forEach(runCallback);
    }
};

export function addWindowResizeCallback(callback, run = false) {
    let allGood = true; let
        result = null;

    if (callback) {
        let objCallback = {};

        if (callback.constructor === Object) {
            if (callback.fn) {
                objCallback = { name: callback.name || short.generate(), fn: callback.fn, ctx: callback.ctx || window };
            } else {
                allGood = false;
            }
        } else {
            objCallback = { name: short.generate(), fn: callback, ctx: window };
        }

        if (allGood) {
            if (!eventAdded) {
                window.addEventListener("resize", runCallbacks, false);
                window.addEventListener("orientationchange", runCallbacks, false);
                eventAdded = true;
            }

            resizeCallbacks.push(objCallback);
            result = objCallback.name;
            if (run) {
                runCallback(objCallback);
            }
        }
    } else {
        allGood = false;
    }

    if (!allGood) {
        console.warn(consoleWarn);
    }

    return result;
}
